import { isFunction } from '../../../utils/isFunction';
import { startApplePaySession } from './util/startApplePaySession';
var ApplePayProvider = (function () {
    function ApplePayProvider(target, targetOrigin, request) {
        this.target = target;
        this.targetOrigin = targetOrigin;
        this.request = request;
        this.canMakePayments = false;
        this.session = null;
        this.validateMerchantCallback = null;
        this.authorizePaymentCallback = null;
        if (window.ApplePaySession) {
            this.canMakePayments = ApplePaySession.canMakePayments();
        }
        this.listener = this.listener.bind(this);
    }
    ApplePayProvider.prototype.start = function () {
        if (!this.canMakePayments) {
            throw new Error('No Apple Pay support');
        }
        window.addEventListener('message', this.listener);
    };
    ApplePayProvider.prototype.stop = function () {
        window.removeEventListener('message', this.listener);
        if (this.session) {
            this.session.abort();
        }
        this.cleanupSession();
    };
    ApplePayProvider.prototype.cleanupSession = function () {
        this.validateMerchantCallback = null;
        this.authorizePaymentCallback = null;
        this.session = null;
    };
    ApplePayProvider.prototype.initiateSession = function () {
        var _this = this;
        var onDone = function () {
            _this.cleanupSession();
        };
        var onCancel = function () {
            _this.target.postMessage({
                type: '@apple-pay-trust/cancelled',
                payload: {}
            }, _this.targetOrigin);
        };
        var onValidateMerchant = function (url) {
            if (isFunction(_this.validateMerchantCallback)) {
                _this.validateMerchantCallback(null);
                _this.validateMerchantCallback = null;
            }
            _this.target.postMessage({
                type: '@apple-pay-trust/validate-merchant',
                payload: { url: url }
            }, _this.targetOrigin);
            return new Promise(function (resolve, reject) {
                _this.validateMerchantCallback = function (session) {
                    if (session) {
                        resolve(session);
                    }
                    else {
                        reject();
                    }
                };
            });
        };
        var onAuthorizePayment = function (token) {
            if (isFunction(_this.authorizePaymentCallback)) {
                _this.authorizePaymentCallback(false);
                _this.authorizePaymentCallback = null;
            }
            _this.target.postMessage({
                type: '@apple-pay-trust/authorize-payment',
                payload: { token: token }
            }, _this.targetOrigin);
            return new Promise(function (resolve, reject) {
                _this.authorizePaymentCallback = function (success) {
                    if (success) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                };
            });
        };
        this.session = startApplePaySession({
            request: this.request,
            onValidateMerchant: onValidateMerchant,
            onAuthorizePayment: onAuthorizePayment,
            onCancel: onCancel,
            onDone: onDone
        });
    };
    ApplePayProvider.prototype.listener = function (evt) {
        if (evt.origin && evt.origin !== this.targetOrigin) {
            return;
        }
        var msg = evt.data;
        if (!msg.type || !msg.type.startsWith('@apple-pay-trust')) {
            return;
        }
        switch (msg.type) {
            case '@apple-pay-trust/start':
                this.initiateSession();
                break;
            case '@apple-pay-trust/merchant-session':
                {
                    var merchantSession = msg.payload.session;
                    if (isFunction(this.validateMerchantCallback)) {
                        this.validateMerchantCallback(merchantSession);
                        this.validateMerchantCallback = null;
                    }
                }
                break;
            case '@apple-pay-trust/finish':
                {
                    var success = msg.payload.success;
                    if (isFunction(this.authorizePaymentCallback)) {
                        this.authorizePaymentCallback(success);
                        this.authorizePaymentCallback = null;
                    }
                }
                break;
            case '@apple-pay-trust/destroy':
                if (this.session) {
                    this.session.abort();
                }
                this.cleanupSession();
                break;
        }
    };
    return ApplePayProvider;
}());
export { ApplePayProvider };
